export default __webpack_public_path__ + "static/media/layout-2.73b8fced.jpg";